const BREAKPOINTS = [
    { key: 'default', label: 'Default', px: null },
    { key: 'sm',  label: 'SM',  px: 640 },
    { key: 'md',  label: 'MD',  px: 768 },
    { key: 'lg',  label: 'LG',  px: 1024 },
    { key: 'xl',  label: 'XL',  px: 1280 },
    { key: '2xl', label: '2XL', px: 1536 },
];

const SIZE_PRESETS = [
    { value: '100vw', label: '100vw' },
    { value: '75vw',  label: '75vw' },
    { value: '50vw',  label: '50vw' },
    { value: '33vw',  label: '33vw' },
    { value: '25vw',  label: '25vw' },
];

function bpLabel(key) {
    const bp = BREAKPOINTS.find((b) => b.key === key);
    if (!bp) return key;
    return bp.px ? `${bp.label} ≥${bp.px}` : bp.label;
}

function parseSizes(component) {
    const raw = component.getAttributes()['data-sizes'];
    if (!raw) return {};
    try { return JSON.parse(raw); } catch { return {}; }
}

function saveSizes(component, sizes) {
    const cleaned = Object.fromEntries(
        Object.entries(sizes).filter(([, v]) => v !== '')
    );
    if (Object.keys(cleaned).length === 0) {
        component.removeAttributes('data-sizes');
    } else {
        component.addAttributes({ 'data-sizes': JSON.stringify(cleaned) });
    }
    component.em.trigger('component:update', component);
}

function buildEntryTag(bpKey, value, onRemove) {
    const tag = document.createElement('div');
    tag.style.cssText =
        'display:inline-flex;align-items:center;gap:4px;' +
        'border:1px solid #4a4a6a;border-radius:4px;padding:2px 6px 2px 8px;' +
        'font-size:13px;color:#ccc;white-space:nowrap;';

    const text = document.createElement('span');
    text.textContent = `${bpLabel(bpKey)}: ${value}`;

    const removeBtn = document.createElement('span');
    removeBtn.textContent = '×';
    removeBtn.style.cssText =
        'cursor:pointer;color:#888;font-size:13px;line-height:1;padding:0 2px;' +
        'border-radius:2px;';
    removeBtn.addEventListener('mouseenter', () => { removeBtn.style.color = '#ff6b6b'; });
    removeBtn.addEventListener('mouseleave', () => { removeBtn.style.color = '#888'; });
    removeBtn.addEventListener('click', (e) => { e.stopPropagation(); onRemove(); });

    tag.append(text, removeBtn);
    return tag;
}

export default (editor, config = {}) => {
    const tm = editor.TraitManager;

    tm.addType('responsive-sizes', {
        noLabel: true,

        createInput({ trait }) {
            const component = trait.target;

            const wrapper = document.createElement('div');
            wrapper.style.cssText = 'width:100%;margin:4px 0;';

            const header = document.createElement('div');
            header.style.cssText =
                'display:flex;align-items:center;justify-content:space-between;' +
                'cursor:pointer;padding:4px 0;user-select:none;';

            const headerLeft = document.createElement('div');
            headerLeft.style.cssText = 'display:flex;align-items:center;gap:6px;';

            const arrow = document.createElement('span');
            arrow.textContent = '▸';
            arrow.style.cssText = 'font-size:10px;color:#888;transition:transform .15s;';

            const titleText = document.createElement('span');
            titleText.textContent = 'Scrset Größen';
            titleText.style.cssText = 'font-size:14px;color:#ccc;';

            const badge = document.createElement('span');
            badge.style.cssText =
                'background:#0991b2;color:#fff;font-size:10px;border-radius:8px;' +
                'padding:0 5px;line-height:16px;min-width:16px;text-align:center;display:none;';

            headerLeft.append(arrow, titleText, badge);
            header.appendChild(headerLeft);

            const body = document.createElement('div');
            body.style.cssText = 'display:none;flex-direction:column;gap:6px;padding-top:6px;';

            const tagsContainer = document.createElement('div');
            tagsContainer.style.cssText = 'display:flex;flex-wrap:wrap;gap:4px;';

            const addRow = document.createElement('div');
            addRow.style.cssText = 'display:flex;align-items:center;gap:4px;width:100%;';

            const selectCss =
                'border:1px solid #444;border-radius:4px;' +
                'color:#fff;font-size:14px;padding:4px 8px;outline:none;cursor:pointer;';

            const bpSelect = document.createElement('select');
            bpSelect.style.cssText = `flex:1;min-width:0;${selectCss}`;

            const sizeSelect = document.createElement('select');
            sizeSelect.style.cssText = `flex:1;min-width:0;${selectCss}`;

            const customInput = document.createElement('input');
            customInput.type = 'text';
            customInput.placeholder = 'e.g. calc(50vw-2rem)';
            customInput.style.cssText =
                `flex:1;min-width:0;display:none;${selectCss}cursor:text;`;

            const addBtn = document.createElement('button');
            addBtn.textContent = '+';
            addBtn.style.cssText =
                'background:#0991b2;color:#fff;border:none;border-radius:4px;' +
                'width:24px;height:24px;font-size:14px;cursor:pointer;display:flex;' +
                'align-items:center;justify-content:center;flex-shrink:0;';

            addRow.append(bpSelect, sizeSelect, customInput, addBtn);
            body.append(tagsContainer, addRow);
            wrapper.append(header, body);

            let isOpen = false;

            const refreshBpOptions = () => {
                const sizes = parseSizes(component);
                const usedKeys = new Set(Object.keys(sizes));
                bpSelect.innerHTML = '';
                BREAKPOINTS.filter((bp) => !usedKeys.has(bp.key)).forEach((bp) => {
                    const opt = document.createElement('option');
                    opt.value = bp.key;
                    opt.textContent = bp.px ? `${bp.label} ≥${bp.px}` : bp.label;
                    bpSelect.appendChild(opt);
                });
                const allUsed = bpSelect.options.length === 0;
                addRow.style.display = allUsed ? 'none' : 'flex';
            };

            const refreshSizeOptions = () => {
                sizeSelect.innerHTML = '';
                SIZE_PRESETS.forEach((p) => {
                    const opt = document.createElement('option');
                    opt.value = p.value;
                    opt.textContent = p.label;
                    sizeSelect.appendChild(opt);
                });
                const customOpt = document.createElement('option');
                customOpt.value = '__custom__';
                customOpt.textContent = 'Custom…';
                sizeSelect.appendChild(customOpt);
            };

            const refreshTags = () => {
                const sizes = parseSizes(component);
                tagsContainer.innerHTML = '';
                const keys = Object.keys(sizes);
                const ordered = BREAKPOINTS.map((b) => b.key).filter((k) => keys.includes(k));
                ordered.forEach((key) => {
                    const tag = buildEntryTag(key, sizes[key], () => {
                        const current = parseSizes(component);
                        delete current[key];
                        saveSizes(component, current);
                        refresh();
                    });
                    tagsContainer.appendChild(tag);
                });
                badge.textContent = keys.length;
                badge.style.display = keys.length > 0 ? '' : 'none';
            };

            const refresh = () => {
                refreshTags();
                refreshBpOptions();
                refreshSizeOptions();
            };

            header.addEventListener('click', () => {
                isOpen = !isOpen;
                arrow.style.transform = isOpen ? 'rotate(90deg)' : '';
                body.style.display = isOpen ? 'flex' : 'none';
                if (isOpen) refresh();
            });

            sizeSelect.addEventListener('change', () => {
                if (sizeSelect.value === '__custom__') {
                    customInput.style.display = '';
                    customInput.focus();
                } else {
                    customInput.style.display = 'none';
                    customInput.value = '';
                }
            });

            const addEntry = () => {
                const bpKey = bpSelect.value;
                if (!bpKey) return;
                let value = sizeSelect.value === '__custom__'
                    ? customInput.value.trim()
                    : sizeSelect.value;
                if (!value) return;

                const current = parseSizes(component);
                current[bpKey] = value;
                saveSizes(component, current);
                customInput.value = '';
                customInput.style.display = 'none';
                sizeSelect.value = SIZE_PRESETS[0].value;
                refresh();
            };

            addBtn.addEventListener('click', addEntry);
            customInput.addEventListener('keydown', (e) => {
                if (e.key === 'Enter') { e.preventDefault(); addEntry(); }
            });

            const sizes = parseSizes(component);
            const count = Object.keys(sizes).length;
            badge.textContent = count;
            badge.style.display = count > 0 ? '' : 'none';

            return wrapper;
        },

        onUpdate() {},
        onEvent() {},
    });
};
